import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/Card/Card";
import dados from "../data/projetosGerais.json";

function RV() {
  const navigate = useNavigate();
  const projetosRV = dados.filter((p) => p.tags.includes("RV"));

  const handleCardClick = (id) => {
    navigate(`/projeto/${id}`);
  };

  return (
    <div className="pagina-categoria">
      <h1>Projetos de Realidade Virtual</h1>
      <div className="cards-container">
        {projetosRV.map((projeto) => (
          <Card key={projeto.id} projeto={projeto} onClick={handleCardClick} />
        ))}
      </div>
    </div>
  );
}

export default RV;
